export const ACTIVITIES_ROUTES = {
  SEARCH_ROUTE: "search",
  AVAILABILITY_ROUTE: "availability",
  SHOP_ROUTE: "shop",
  BOOK_ROUTE: "book",
};

export const ACTIVITIES_SEARCH_CALENDAR_HASH = "#calendar";

export const ACTIVITIES_AVAILABILITY_PARAMS = ":location/:placeId?";
export const ACTIVITIES_PATH = `/activities`;

export const ACTIVITIES_SEARCH_PATH = `${ACTIVITIES_PATH}/${ACTIVITIES_ROUTES.SEARCH_ROUTE}`;

export const ACTIVITIES_AVAILABILITY_PATH = `${ACTIVITIES_PATH}/${ACTIVITIES_ROUTES.AVAILABILITY_ROUTE}`;

export const ACTIVITIES_SHOP_PATH = `${ACTIVITIES_PATH}/${ACTIVITIES_ROUTES.SHOP_ROUTE}`;
export const ACTIVITIES_BOOK_PATH = `${ACTIVITIES_PATH}/${ACTIVITIES_ROUTES.BOOK_ROUTE}`;

export const ACTIVITIES_ERROR_PATH = "/activities";
